<template>
  <v-navigation-drawer id="app-drawer" v-model="inputValue" :src="image" app color="grey darken-2" dark floating mobile-break-point="991" persistent>
    <template v-slot:img="attrs">
      <v-img v-bind="attrs" gradient="to top, rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)" />
    </template>

    <v-list-item two-line to="/">
      <v-list-item-avatar color="white">
        <v-img :src="logo" height="34" contain />
      </v-list-item-avatar>

      <v-list-item-title class="title">{{ $t("Common.title") }}</v-list-item-title>

      <v-btn icon @click.prevent="onClick">
        <v-icon>minimize</v-icon>
      </v-btn>
    </v-list-item>

    <v-divider class="mx-3 mb-3" />

    <v-list nav>
      <!-- Bug in Vuetify for first child of v-list not receiving proper border-radius -->
      <div />

      <template v-for="(item, i) in menu">
        <v-tooltip right v-bind:key="'item_' + i">
          <template v-slot:activator="{ on }">
            <v-list-item v-if="!item.children" active-class="primary white--text" class="v-list-item" v-on="on" :to="item.to">
              <v-list-item-action v-if="item.icon">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-title v-text="item.text" />
            </v-list-item>
          </template>
          <span>{{ item.tooltip }}</span>
        </v-tooltip>

        <v-list-group v-if="item.children" v-bind:key="'group_' + i">
          <template v-slot:activator ripple="ripple">
            <v-list-item>
              <!-- <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon> -->

              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item>
          </template>

          <v-tooltip right v-for="(subitem, j) in item.children" v-bind:key="'subitem_' + j">
            <template v-slot:activator="{ on }">
              <v-list-item active-class="primary white--text" class="v-list-item" v-on="on" :to="subitem.to">
                <!-- <v-list-item-action></v-list-item-action> -->
                <v-list-item-content class="pl-7">
                  {{ subitem.text }}
                  <!-- <v-list-item-title></v-list-item-title> -->
                </v-list-item-content>
              </v-list-item>
            </template>
            <span>{{ subitem.tooltip }}</span>
          </v-tooltip>
        </v-list-group>
      </template>
    </v-list>

    <!-- <template v-slot:append>
      <v-list nav>
        <v-list-item href="https://www.assistedcoding.eu">
          <v-list-item-action>
            <v-icon>school</v-icon>
          </v-list-item-action>

          <v-list-item-title class="font-weight-light">www.assistedcoding.eu</v-list-item-title>
        </v-list-item>
      </v-list>
    </template> -->
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapMutations, mapState } from "vuex";
// import VuePerfectScrollbar from "vue2-perfect-scrollbar";
import menu from "@/config/menu.js";

export default {
  // components: {
  //   VuePerfectScrollbar
  // },
  props: {
    opened: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    logo: require("@/app/resources/img/owl.png"),
    menu: menu
  }),

  computed: {
    ...mapState("app", ["image", "color"]),
    inputValue: {
      get() {
        return this.$store.state.app.drawer;
      },
      set(val) {
        this.setDrawer(val);
      }
    }
  },

  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
    onClick() {
      this.setDrawer(!this.$store.state.app.drawer);
    }
  }
};
</script>
